module.exports = __webpack_public_path__ + "static/media/shellshuanshim.322b4db1.jpg";